import Head from 'components/next/Head';
import dateFormat from 'dateformat';
import { GetStaticProps } from 'next';
import LandaFinancingBackground from 'pages/lend/components/LandaFinancingBackground';
import LandaFinancingHeader from 'pages/lend/components/LandaFinancingHeader';
import { tryRequest } from 'pages/lend/dataFetching';
import useDebtDarkMode from 'pages/lend/hooks/useDebtDarkMode';
import {
  LANDA_FINANCING_LEFT_COMPONENTS,
  LANDA_FINANCING_RIGHT_COMPONENTS,
} from 'pages/lend/utils';
import React, { useEffect } from 'react';
import { DebtType } from 'types/debt-types';
import classes from './index.module.scss';
import useUserDetails from '../../hooks/requests/user/hooks/useUserDetails';
import { useLandaRouter } from '../../hooks/logics/useLandaRouter';
import { FEED_ROUTE } from '../../consts/routes/urls';

const DebtPage = ({ debt }: { debt: DebtType }) => {
  useDebtDarkMode();
  const { userDetails } = useUserDetails();
  const { router } = useLandaRouter();
  useEffect(() => {
    if (userDetails?.isTenant) {
      router.replace(FEED_ROUTE);
    }
  }, [userDetails]);

  return (
    <div className={classes.outerContainer}>
      <div className={classes.container}>
        <Head title={'Lend - invest in mortgages with Landa'} />
        <LandaFinancingBackground />
        <LandaFinancingHeader
          debt={debt}
          className={classes.header}
        />
        <div className={classes.content}>
          <div className={classes.leftList}>
            {LANDA_FINANCING_LEFT_COMPONENTS.map(({ Component, key }) => (
              <Component
                key={key}
                debt={debt}
              />
            ))}
          </div>
          <div className={classes.rightList}>
            {LANDA_FINANCING_RIGHT_COMPONENTS.map(({ Component, key }) => (
              <Component
                key={key}
                debt={debt}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const toDate = dateFormat(
    new Date(new Date().setDate(1)).setMonth(new Date().getMonth() + 1),
    'yyyy-mm-dd'
  );

  const fromDate = dateFormat(
    new Date(new Date().setDate(1)).setMonth(new Date().getMonth() - 5),
    'yyyy-mm-dd'
  );

  const response = await tryRequest(3, { toDate, fromDate });

  if (!response || !response?.landaFinancingReit) {
    return {
      notFound: true,
    };
  }
  const debt = response?.landaFinancingReit;
  return {
    props: { debt },
    revalidate: 60,
  };
};

export default DebtPage;
